import { categories, siteContact } from "@/mocks/gossip";

const nav = [
  { href: "#hot", label: "焦点速览" },
  { href: "#timeline", label: "本月时间线" },
  { href: "#guide", label: "内容导览" },
  { href: "#faq", label: "常见问题" },
  { href: "#about", label: "关于本站" },
];

export default function Footer() {
  const year = new Date().getFullYear();
  const catList = categories.filter((c) => c !== "全部");

  return (
    <footer className="bg-primary-950 text-primary-100">
      <div className="container-x grid gap-10 py-12 md:grid-cols-2 md:py-14 lg:grid-cols-[1.4fr_1fr_1fr_1.2fr] lg:gap-8">
        <div>
          <a href="#top" className="flex items-center gap-2.5 whitespace-nowrap">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-500 text-foreground-950">
              <i className="ri-fire-fill text-lg"></i>
            </span>
            <span className="font-heading text-xl font-bold text-background-50">
              本月大瓜<span className="text-accent-400">时间线</span>
            </span>
          </a>
          <p className="mt-4 max-w-xs text-sm leading-6 text-primary-200/90">
            脉络清晰，吃瓜不迷路。专注把本月大瓜按发生顺序整理成完整经过，帮你快速看懂每一件事的发展全过程。
          </p>
          <a
            href={`mailto:${siteContact.email}`}
            className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-background-50/10 px-4 py-2 text-sm text-background-50 ring-1 ring-background-50/20 transition-colors hover:bg-background-50/20"
          >
            <i className="ri-mail-line"></i> {siteContact.email}
          </a>
        </div>

        <nav aria-label="站内导航">
          <h4 className="font-heading text-sm font-bold text-background-50">快速浏览</h4>
          <ul className="mt-4 space-y-2.5 text-sm">
            {nav.map((n) => (
              <li key={n.href}>
                <a href={n.href} className="inline-flex items-center gap-2 text-primary-200/90 transition-colors hover:text-accent-300">
                  <i className="ri-arrow-right-s-line text-accent-400"></i> {n.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <nav aria-label="内容栏目">
          <h4 className="font-heading text-sm font-bold text-background-50">吃瓜门类</h4>
          <ul className="mt-4 space-y-2.5 text-sm">
            {catList.map((c) => (
              <li key={c}>
                <a href="#timeline" className="inline-flex items-center gap-2 text-primary-200/90 transition-colors hover:text-accent-300">
                  <i className="ri-price-tag-3-line text-accent-400"></i> {c}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <div>
          <h4 className="font-heading text-sm font-bold text-background-50">订阅本月瓜报</h4>
          <p className="mt-4 text-sm leading-6 text-primary-200/90">
            每周一整理一期上月与本周值得重看的大瓜脉络，直接发送到你的邮箱。
          </p>
          <a
            href="#contact"
            className="mt-4 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-accent-500 px-5 py-2.5 text-sm font-semibold text-foreground-950 transition-colors hover:bg-accent-400"
          >
            前往订阅/反馈 <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>
      </div>

      <div className="border-t border-background-50/15">
        <div className="container-x flex flex-col gap-2 py-6 text-xs text-primary-300/80 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} 本月大瓜时间线 · 保留所有权利。本站为公开文娱信息整理站点。</p>
          <p className="whitespace-nowrap">脉络清晰，吃瓜不迷路 · {siteContact.slogan}</p>
        </div>
      </div>
    </footer>
  );
}